"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDropzone = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const utils_1 = require("@obvio/utils");
const Label_1 = require("./Label");
const Button_1 = require("../../../Button");
const DraggableList_1 = require("../../../DraggableList");
const Grid_1 = require("../../../Grid");
const Loading_1 = require("../../../Loading");
const Stack_1 = require("../../../Stack");
const StyledDropzone = app_1.styled.div `
  display: flex;
  width: 100%;
  gap: ${(theme) => theme.spacing.small};
  flex-wrap: wrap;
  position: relative;
  border: 0.0625rem dashed ${(theme) => theme.stroke};
  min-height: 7rem;
  overflow: hidden;
  border-radius: ${(theme) => theme.radius.big};
  padding: ${(theme) => theme.spacing.medium};
  &[aria-invalid] {
    border-color: ${(theme) => theme.colors.error};
  }
`;
const StyledOverlay = app_1.styled.div `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 2rem;
  background-color: rgba(255, 255, 255, 0.5);
`;
const DefaultFile = (0, app_1.styled)(Grid_1.Grid) `
  width: 100%;
  font-size: 0.8125rem;
  padding: ${(theme) => theme.spacing.small};
  border-radius: ${(theme) => theme.radius.small};
  border: 1px solid ${(theme) => theme.colors.gray.light};
  background-color: ${(theme) => theme.colors.gray.intense};
  font-size: 1.0625rem;
`;
const RemoveButton = (0, app_1.styled)(Button_1.Button) `
  height: auto;
`;
const FileName = app_1.styled.span `
  ${(theme) => theme.truncate}
  color: ${(theme) => theme.colors.gray.semidark};
  font-weight: 500;
`;
const FileSize = app_1.styled.span `
  ${(theme) => theme.truncate}
  color: ${(theme) => theme.colors.gray};
`;
function DefaultFileRenderer({ file, removeFile, dragHandleProps: _drag, }) {
    const size = 'size' in file ? (file.size / (1024 * 1024)).toFixed(2) : '--';
    return ((0, jsx_runtime_1.jsxs)(DefaultFile, Object.assign({ templateColumns: "auto 1fr auto", gap: "small" }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.GridItem, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgFile, {}) }), (0, jsx_runtime_1.jsxs)(Grid_1.Grid, Object.assign({ templateRows: "1fr 1fr" }, { children: [(0, jsx_runtime_1.jsx)(FileName, { children: file.name }), (0, jsx_runtime_1.jsxs)(FileSize, { children: [size, "mb"] })] })), (0, jsx_runtime_1.jsx)(RemoveButton, Object.assign({ kind: ['icon', 'transparent'], onClick: () => {
                    removeFile === null || removeFile === void 0 ? void 0 : removeFile(file);
                } }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgBin, {}) }))] })));
}
function DefaultDropzone({ wrapperProps, children, files, dragging, processing, fileRenderer: FileRenderer = DefaultFileRenderer, canAdd, label, id, optional, removeFile, addFile, setFiles, }) {
    return ((0, jsx_runtime_1.jsxs)(Stack_1.Stack, Object.assign({ kind: "vertical", fullWidth: true }, { children: [Boolean(label) && ((0, jsx_runtime_1.jsx)(Label_1.Label, Object.assign({ optional: Boolean(optional), htmlFor: id, inputKind: "file", className: (0, utils_1.cls)({
                    'with-value': files.length > 0,
                }) }, { children: label }))), canAdd ? ((0, jsx_runtime_1.jsxs)(StyledDropzone, Object.assign({}, wrapperProps, { onClick: addFile }, { children: [processing ? (0, jsx_runtime_1.jsx)(Loading_1.LoadingOverlay, {}) : children, dragging && (0, jsx_runtime_1.jsx)(StyledOverlay, { children: "Drop files here!" })] }))) : null, (0, jsx_runtime_1.jsx)(DraggableList_1.DraggableList, { data: files.map((v) => ({ id: v.name, file: v })), setData: setFiles, render: ({ file, id: fileId }, dProps) => ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { width: '100%' }, ref: (v) => dProps.innerRef(v) }, dProps.draggableProps, { children: (0, jsx_runtime_1.jsx)(FileRenderer, { file: file, removeFile: removeFile, dragHandleProps: dProps.dragHandleProps }, file.name) }), fileId)) })] })));
}
exports.DefaultDropzone = DefaultDropzone;
